// composables/useLogoutAndClearCart.ts
import { useUserStore } from '~/store/userStore';
import { useCartStore } from '~/store/cartStore'; // Adjust the import path as per your project structure

export function useLogoutAndClearCart() {
  const userStore = useUserStore();
  const cartStore = useCartStore();

  const logoutAndClearCart = async () => {
    try {
      await userStore.logout(); // Logout the user
      await cartStore.emptyCart(); // Clear the cart
    } catch (error) {
      console.error('Error during logout and clearing cart:', error);
    }
  };

  return { logoutAndClearCart };
}
